<template>
  <div>
    <el-select @change="handleFilter" style="width: 250px;" v-model="currentSortBy" :value="0" placeholder="Sort by">
      <el-option
        v-for="item in campaignSortByList"
        :key="item.type"
        :label="item.title"
        :value="item.type"
      ></el-option>
    </el-select>
    <el-input
      placeholder="Title"
      style="width: 300px"
      v-model="currentTitle"
      @input="handleDebounceFilter"
      @keyup.enter.native="handleFilter"
    ></el-input>
    <el-select @change="handleFilter" v-model="currentType" :value="0" placeholder="Campaign type">
      <el-option
        v-for="item in campaignTypeList"
        :key="item.type"
        :label="item.title"
        :value="item.type"
      ></el-option>
    </el-select>

    <el-radio-group v-model="currentIsActive" @input="handleDebounceFilter" style="margin-top: 1px">
      <el-radio-button :label="true">Active</el-radio-button>
      <el-radio-button :label="false">Inactive</el-radio-button>
    </el-radio-group>
  </div>
</template>

<script>
/* eslint-disable space-before-function-paren, func-names, prefer-arrow-callback */
import { mapState } from 'vuex';
import { debounce } from 'lodash';
import SocialIcon from '@/components/common/Icons/SocialIcon';

export default {
  name: 'CampaignFilter',
  components: {
    SocialIcon,
  },
  data: () => ({
    campaignTypeList: [
      { type: null, title: 'All' },
      { type: 'message_board', title: 'Message boards' },
      { type: 'competition', title: 'Competitions' },
      { type: 'poll', title: 'Poll' },
      { type: 'survey', title: 'Survey' },
      { type: 'instant_poll', title: 'Instant Polls' },
    ],
    campaignSortByList: [
      { type: 'start_date_ascending', title: 'Start date - Earliest to Latest' },
      { type: 'start_date_descending', title: 'Start date - Latest to Earliest' },
      { type: 'end_date_ascending', title: 'End date - Earliest to Latest' },
      { type: 'end_date_descending', title: 'End date - Latest to Earliest' },
      { type: 'title_ascending', title: 'Title - A to Z' },
      { type: 'title_descending', title: 'Title - Z to A' },
    ],
    currentFilters: {
      title: null,
      type: null,
      isActive: null,
      sortBy: null,
    },
    hasFiltered: {
      title: false,
      type: false,
      isActive: false,
      sortBy: false,
    },
  }),
  computed: {
    ...mapState('campaign', ['filterTitle', 'filterType', 'filterIsActive', 'filterSortBy']),

    currentTitle: {
      get() {
        return this.hasFiltered.title ? this.currentFilters.title : this.filterTitle;
      },
      set(title) {
        this.currentFilters.title = title;
        this.hasFiltered.title = true;
      },
    },

    currentType: {
      get() {
        return this.hasFiltered.type ? this.currentFilters.type : this.filterType;
      },
      set(type) {
        this.currentFilters.type = type;
        this.hasFiltered.type = true;
      },
    },

    currentIsActive: {
      get() {
        return this.hasFiltered.isActive ? this.currentFilters.isActive : this.filterIsActive;
      },
      set(isActive) {
        this.currentFilters.isActive = isActive;
        this.hasFiltered.isActive = true;
      },
    },

    currentSortBy: {
      get() {
        return this.hasFiltered.sortBy ? this.currentFilters.sortBy : this.filterSortBy;
      },
      set(sortBy) {
        this.currentFilters.sortBy = sortBy;
        this.hasFiltered.sortBy = true;
      },
    },
  },
  methods: {
    handleFilter() {
      this.$emit('onFilter', {
        title: this.currentTitle,
        type: this.currentType,
        isActive: this.currentIsActive,
        sortBy: this.currentSortBy,
      });
    },
    handleDebounceFilter: debounce(function() {
      this.handleFilter();
    }, 500),
  },
};
</script>



// WEBPACK FOOTER //
// CampaignFilter.vue?83dfcb68